export enum MessageType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
}
// 需要用 key 来优化
interface MessageKey {
    key?: React.Key // 没有 id 就会用当前时间戳(固定值)作为 key 来优化
    id?: string // 返回的列表都有  id
}

// 消息体
export interface TextMessageContent {
    content: string
}
export interface ImageMessageContent {
    img_url: string // 储存链接地址
}

// 消息体 + 类型
export interface TextMessage extends TextMessageContent {
    type: MessageType.TEXT
}

export interface ImageMessage extends ImageMessageContent {
    type: MessageType.IMAGE
}

// 消息体 + 类型  + key
export interface TextMessageDefaultType extends TextMessage, MessageKey {}
export interface ImageMessageDefaultType extends ImageMessage, MessageKey {}

export type MessageContent = TextMessageContent | ImageMessageContent

export type MessageItemType = TextMessageDefaultType | ImageMessageDefaultType
